
export default function CancelButtonDirective() {
    'ngInject';
    return {
        template: require('./cancel-button.html'),
        transclude: true,
        restrict: 'E',
        scope: {
            disabled: '='
        }
    };
}
